import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetAllFrontVersionsOutput } from './GetAllFrontVersionsOutput';

export class GetAllFrontVersionsService extends HttpServiceBase {

  handle = (): Promise<Result<GetAllFrontVersionsOutput> | null> => {
    const promise = this.http.get<Result<GetAllFrontVersionsOutput>>(`${this.baseUrlSislogApi}/v2/front-version`);
    return promise;
  }
}